import React from "react";
import PropTypes from "prop-types";

function CollectionQnaItem({ question, answer, answerPrefix }) {
    return (
        <article className="CollectionCortisQna">
            <h3 className="CollectionCortisQna-question">{question}</h3>
            <p className="CollectionCortisQna-answer">
                {answerPrefix ? <strong className="CollectionCortisQna-prefix">{`${answerPrefix}: `}</strong> : null}
                {answer}
            </p>
        </article>
    );
}

CollectionQnaItem.propTypes = {
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
    answerPrefix: PropTypes.string,
};

export default React.memo(CollectionQnaItem);
